// extracted by mini-css-extract-plugin
module.exports = {"buttonPrimary":"buttons_buttonPrimary__Z77Hg"};